import {
  ALLOW_TO_ENTER_WAITING_LIST_MAX,
  AutomationTypeEnum,
  AutomationChannelEnum,
  PostVisitAudienceEnum,
  WAITING_LIST_MAX_DAYS_LIMIT,
  WHATSAPP_FREE_TEXT_DEFAULTS,
  type IAutomationTypeMeta,
  type IAutomationConfig,
} from '@torim-app/types';

export const automationTypesConfig: IAutomationTypeMeta[] = [
  {
    type: AutomationTypeEnum.AppointmentReminder,
    name: 'תזכורת לתור',
    description: 'שליחת תזכורת ללקוח/ה X ימים לפני התור',
    icon: 'pi-bell',
    color: '#3b82f6',
    supportsWhatsApp: true,
    // {סניף} is optional: {שם-העסק} already resolves to "עסק - סניף" for a multi-branch
    // business, so the branch tag is only for owners who want it worded differently.
    availableTags: ['שם-הלקוח', 'תאריך', 'שעה', 'שם-העסק', 'קישור-אישור', 'סניף'],
    mandatoryTags: ['שם-הלקוח', 'תאריך', 'שעה', 'שם-העסק', 'קישור-אישור'],
    defaultMessage: 'היי {שם-הלקוח}, יש לך הזמנה לתאריך {תאריך} בשעה {שעה} ל-{שם-העסק}, אשמח אם רק תאשר/י הגעה בקישור המצורף: {קישור-אישור}',
    defaultWhatsAppMessage: 'היי, {שם-הלקוח} 👋\nזומן עבורך תור לתאריך {תאריך} בשעה {שעה} עבור *{שירותים}*.\nלאישור הגעה יש ללחוץ הכפתור הרצוי 👇',
    alwaysOn: true,
    settingsSchema: [
      {
        key: 'sendReminderXDaysBefore',
        label: 'כמה ימים לפני לשלוח תזכורת?',
        type: 'number',
        default: 1,
        suffix: 'ימים',
      },
    ],
  },
  {
    type: AutomationTypeEnum.WaitingListNotification,
    name: 'רשימת המתנה',
    description: 'שליחת הודעה ללקוח/ה כשנמצא תור פנוי ברשימת ההמתנה',
    icon: 'pi-list',
    color: '#06b6d4',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח'],
    defaultMessage: 'היי {שם-הלקוח}, ישנם תורים פנויים ל-{שם-העסק} בזמנים שרצית. לזימון תור: {קישור}',
    defaultWhatsAppMessage: 'היי, {שם-הלקוח} 👋\nלבקשתך, מצאנו עבורך תור זמין לתאריך {תאריך} בשעה {שעה} עבור *{שירותים}*.\nהאם לזמן לך את התור?',
    alwaysOn: true,
    settingsSchema: [
      {
        key: 'waitingListMaxDays',
        label: 'עד כמה ימים קדימה לחפש תור פנוי?',
        type: 'number',
        default: ALLOW_TO_ENTER_WAITING_LIST_MAX,
        max: WAITING_LIST_MAX_DAYS_LIMIT,
        suffix: 'ימים',
      },
    ],
  },
  {
    type: AutomationTypeEnum.BookingConfirmation,
    name: 'אישור הזמנה',
    description: 'שליחת הודעה ללקוח/ה לאחר שקבע/ה תור בהצלחה',
    icon: 'pi-check-circle',
    color: '#22c55e',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח', 'תאריך', 'שעה', 'שם-העסק', 'סניף'],
    mandatoryTags: ['שם-הלקוח', 'תאריך', 'שעה', 'שם-העסק'],
    defaultMessage: 'היי {שם-הלקוח}, זומן לך תור לתאריך {תאריך} בשעה {שעה} ל-{שם-העסק}. שיהיה לך המשך יום מקסים!',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, זומן לך תור לתאריך {תאריך} בשעה {שעה}  ל-{שירותים}. שיהיה לך המשך יום מקסים!',
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.BookingCanceled,
    name: 'ביטול תור',
    description: 'שליחת הודעה ללקוח/ה כאשר תור בוטל',
    icon: 'pi-times-circle',
    color: '#ef4444',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח'],
    defaultMessage: 'היי {שם-הלקוח}, לצערנו התור שלך בתאריך {תאריך} ל-{שם-העסק} בוטל ע"י בית העסק.',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, התור שלך בתאריך {תאריך} *בוטל* ע״י העסק. מתנצלים על אי הנעימות.',
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.AppointmentRescheduled,
    name: 'עדכון תור',
    description: 'שליחת הודעה ללקוח/ה כשהתור שלו/ה מעודכן לתאריך או שעה אחרים',
    icon: 'pi-calendar-plus',
    color: '#6366f1',
    supportsWhatsApp: true,
    defaultOn: true,
    availableTags: ['שם-הלקוח', 'תאריך', 'שעה', 'שם-העסק', 'תאריך-קודם', 'סניף'],
    defaultMessage: 'היי {שם-הלקוח}, רק מעדכנים שהתור שלך ל{שם-העסק} עודכן. התאריך המעודכן: {תאריך} בשעה {שעה}',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, התור שלך עודכן.\nהמועד החדש: {תאריך} בשעה {שעה}.\nנתראה!',
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.SameDayReminder,
    name: 'תזכורת יום הביקור',
    description: 'שליחת תזכורת ללקוח/ה בבוקר של יום התור (בשעה 08:00)',
    icon: 'pi-sun',
    color: '#f59e0b',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח', 'שעה', 'שם-העסק', 'סניף'],
    defaultMessage: 'היי {שם-הלקוח}, רק תזכורת שיש לך היום תור ב-{שם-העסק} בשעה {שעה}. נשמח לראותך :)',
    defaultWhatsAppMessage: 'היי {שם-הלקוח},\nרק מזכירים שיש לך תור *להיום* בשעה {שעה} ל{שירותים}.\nנתראה!',
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.NewCustomerWelcome,
    name: 'הודעה ללקוחות חדשים',
    description: 'שליחת הודעת ברוכים הבאים ללקוח/ה שמזמינ/ה תור לראשונה',
    icon: 'pi-user-plus',
    color: '#14b8a6',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח'],
    defaultMessage: 'היי {שם-הלקוח}, איזה כיף שהצטרפת אלינו! נשמח לראותך.',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, איזה כיף שהצטרפת אלינו!\n{טקסט-חופשי}\nנשמח לראותך בקרוב.',
    whatsAppFreeText: { defaultText: WHATSAPP_FREE_TEXT_DEFAULTS[AutomationTypeEnum.NewCustomerWelcome]! },
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.InvoiceReceipt,
    name: 'שליחת חשבונית',
    description: 'שליחה אוטומטית של חשבונית/קבלה ללקוח לאחר ביצוע תשלום',
    icon: 'pi-receipt',
    color: '#10b981',
    supportsWhatsApp: true,
    requiresInvoiceProvider: true,
    availableTags: ['שם-הלקוח', 'שם-העסק', 'קישור'],
    mandatoryTags: ['קישור'],
    defaultMessage: 'היי {שם-הלקוח}, מצורפת חשבונית מ{שם-העסק} עבור התשלום שביצעת. לצפייה: {קישור}',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, מצורפת חשבונית מ{שם-העסק} עבור התשלום שביצעת.\nלצפייה לחצו על הכפתור 👇',
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.ProductOrderReady,
    name: 'הזמנת מוצרים מוכנה',
    description: 'עדכון אוטומטי ללקוח כשסימנתם את הזמנת המוצרים שלו כמוכנה לאיסוף',
    icon: 'pi-shopping-bag',
    color: '#8b5cf6',
    supportsWhatsApp: true,
    requiresShop: true,
    availableTags: ['שם-הלקוח', 'שם-העסק', 'מספר-הזמנה', 'קישור'],
    defaultMessage: 'היי {שם-הלקוח}, הזמנה מס\' {מספר-הזמנה} מ{שם-העסק} מוכנה לאיסוף! 🛍️ לפרטים: {קישור}',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, הזמנה מס\' {מספר-הזמנה} מ{שם-העסק} מוכנה לאיסוף! 🛍️\nלצפייה בפרטי ההזמנה לחצו על הכפתור 👇',
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.SkinScanReminder,
    name: 'בקשת תמונת מעקב',
    description: 'בקשה אוטומטית מהלקוח/ה לשלוח תמונת פנים למעקב, בתדירות שתבחרו. נשלחת רק ללקוחות עם מעקב פעיל.',
    icon: 'pi-camera',
    color: '#a855f7',
    supportsWhatsApp: true,
    requiresSkinFeature: true,
    availableTags: ['שם-הלקוח', 'שם-העסק', 'קישור'],
    mandatoryTags: ['קישור'],
    defaultMessage: 'היי {שם-הלקוח}, נשמח לתמונת פנים עדכנית למעקב הטיפול ב{שם-העסק} :) לצילום ושליחה: {קישור}',
    defaultWhatsAppMessage: 'היי {שם-הלקוח} 👋\nנשמח לתמונת פנים עדכנית כדי לעקוב אחרי ההתקדמות שלך ב{שם-העסק}.\nלצילום ושליחה 👇\n{קישור}',
    settingsSchema: [
      {
        key: 'frequencyDays',
        label: 'כל כמה ימים לבקש תמונה?',
        type: 'number',
        default: 14,
        suffix: 'ימים',
      },
    ],
  },
  {
    type: AutomationTypeEnum.SmartNudge,
    name: 'מילוי יומן חכם',
    description: 'אל תפספסו אף תור. המערכת מזהה אוטומטית לקוחות שמתעכבים בקביעת הטיפול הבא, ומציעה להם לשבץ תור לשעה הנוחה להם ביותר, ללא כל התעסקות מצידכם.',
    icon: 'pi-bolt',
    color: '#8b5cf6',
    supportsWhatsApp: true,
    availableTags: [],
    defaultMessage: 'היי {שם-הלקוח}! עברו כ-{מחזור} מאז ה{שירותים} האחרון שלך ב{שם-העסק}. יש לי תור פנוי ב{תורים-פנויים}. רוצה שאשמור לך מקום?',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}! 👋\n\nשמנו לב שהגיע הזמן ל{שירותים} שלך.\n\n📅 יש לנו פנוי: {תורים-פנויים}\n\nרוצה שנשמור לך מקום?',
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.ReviewRequest,
    name: 'בקשת משוב',
    description: 'שליחת בקשה לדירוג ומשוב לאחר תור',
    icon: 'pi-star',
    color: '#0ea5e9',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח', 'שם-העסק', 'קישור-משוב'],
    mandatoryTags: ['קישור-משוב'],
    defaultMessage: 'היי {שם-הלקוח}, ביקרת לאחרונה ב-{שם-העסק} ונשמח לקבל ממך משוב :) למילוי המשוב לחצו על הקישור {קישור-משוב}',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, ביקרת לאחרונה ב{שם-העסק} ונשמח לקבל ממך משוב.\nלמילוי המשוב לחצו על הכפתור 👇',
    settingsSchema: [
      {
        key: 'hoursAfter',
        label: 'כמה שעות אחרי התור?',
        type: 'number',
        default: 3,
        suffix: 'שעות',
      },
    ],
  },
  {
    type: AutomationTypeEnum.PostVisitFollowUp,
    name: 'מעקב אחרי ביקור',
    description: 'שליחת הודעת תודה X ימים אחרי תור',
    icon: 'pi-heart',
    color: '#ec4899',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח', 'שם-העסק'],
    defaultMessage: 'היי {שם-הלקוח}, תודה שביקרת אצלנו ב{שם-העסק}! מקווים שנהנית. נשמח לראותך שוב בקרוב!',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, תודה שביקרת אצלנו!\n{טקסט-חופשי}\nנשמח לראותך שוב, לקביעת תור לחצו על הכפתור 👇',
    whatsAppFreeText: { defaultText: WHATSAPP_FREE_TEXT_DEFAULTS[AutomationTypeEnum.PostVisitFollowUp]! },
    settingsSchema: [
      {
        key: 'daysAfter',
        label: 'כמה ימים אחרי הביקור?',
        type: 'number',
        default: 7,
        suffix: 'ימים',
      },
      {
        key: 'audience',
        label: 'למי לשלוח?',
        type: 'select',
        default: PostVisitAudienceEnum.All,
        options: [
          { label: 'לכל הלקוחות', value: PostVisitAudienceEnum.All },
          { label: 'רק ללקוחות חדשים (תור ראשון)', value: PostVisitAudienceEnum.NewCustomers },
        ],
      },
    ],
  },
  {
    type: AutomationTypeEnum.BirthdayGreeting,
    name: 'ברכת יום הולדת',
    description: 'שליחת הודעת ברכה ביום ההולדת של הלקוחות',
    icon: 'pi-gift',
    color: '#eab308',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח'],
    defaultMessage: 'יום הולדת שמח {שם-הלקוח}! 🎂 נשמח לפנק אותך, מחכים לך!',
    defaultWhatsAppMessage: 'יום הולדת שמח {שם-הלקוח}! 🎂\n{טקסט-חופשי}\nמאחלים לך שנה נפלאה.',
    whatsAppFreeText: { defaultText: WHATSAPP_FREE_TEXT_DEFAULTS[AutomationTypeEnum.BirthdayGreeting]! },
    settingsSchema: [],
  },
  {
    type: AutomationTypeEnum.InactiveCustomer,
    name: 'לקוח לא פעיל',
    description: 'שליחת הודעה ללקוחות שלא ביקרו תקופה ארוכה',
    icon: 'pi-user-minus',
    color: '#a855f7',
    supportsWhatsApp: true,
    availableTags: ['שם-הלקוח'],
    defaultMessage: 'היי {שם-הלקוח}, מתגעגעים אלייך! עבר זמן מאז הביקור האחרון. נשמח לראותך שוב.',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, עבר זמן מאז הביקור האחרון שלך.\n{טקסט-חופשי}\nלקביעת תור לחצו על הכפתור 👇',
    whatsAppFreeText: { defaultText: WHATSAPP_FREE_TEXT_DEFAULTS[AutomationTypeEnum.InactiveCustomer]! },
    settingsSchema: [
      {
        key: 'inactiveDays',
        label: 'לאחר כמה ימים ללא ביקור?',
        type: 'number',
        default: 30,
        suffix: 'ימים',
      },
    ],
  },
  {
    type: AutomationTypeEnum.AbandonedScheduling,
    name: 'נטישת הזמנה',
    description: 'שליחת הודעה ללקוחות שהתחילו להזמין תור אך נטשו באמצע',
    icon: 'pi-sign-out',
    color: '#f97316',
    supportsWhatsApp: true,
    comingSoon: true,
    availableTags: ['שם-הלקוח'],
    defaultMessage: 'היי {שם-הלקוח}, שמתי שהתחלת להזמין תור ולא סיימת. צריך/ה עזרה? נשמח לסייע!',
    defaultWhatsAppMessage: 'היי {שם-הלקוח}, שמתי שהתחלת להזמין תור ולא סיימת. צריך/ה עזרה? נשמח לסייע!',
    settingsSchema: [
      {
        key: 'timeoutMinutes',
        label: 'לאחר כמה דקות לשלוח?',
        type: 'number',
        default: 10,
        suffix: 'דקות',
      },
    ],
  },
  // {
  //   type: AutomationTypeEnum.NoShowFollowUp,
  //   name: 'מעקב אי-הגעה',
  //   description: 'שליחת הודעה ללקוחות שלא הגיעו לתור שנקבע',
  //   icon: 'pi-exclamation-circle',
  //   color: '#f43f5e',
  //   supportsWhatsApp: true,
  //   availableTags: ['שם-הלקוח', 'קישור-הזמנה'],
  //   defaultMessage: 'היי {שם-הלקוח}, פספסנו אותך! רוצה לקבוע תור חדש? {קישור-הזמנה}',
  //   defaultWhatsAppMessage: 'היי {שם-הלקוח}, פספסנו אותך בתור שנקבע לתאריך {תאריך}.\nלקביעת תור חדש לחצו על הכפתור 👇',
  //   settingsSchema: [],
  // },
];

export const automationTypesMeta = Object.fromEntries(
  automationTypesConfig.map(m => [m.type, m])
) as Record<AutomationTypeEnum, IAutomationTypeMeta>;

export const getDefaultMessage = (type: AutomationTypeEnum, channel: AutomationChannelEnum): string => {
  const meta = automationTypesMeta[type];
  if (channel === AutomationChannelEnum.WhatsApp && meta.defaultWhatsAppMessage) {
    return meta.defaultWhatsAppMessage;
  }
  return meta.defaultMessage;
};

export const createDefaultConfig = (type: AutomationTypeEnum): IAutomationConfig => {
  const meta = automationTypesMeta[type];
  const settings: Record<string, any> = {};
  for (const field of meta.settingsSchema) {
    settings[field.key] = field.default;
  }
  return {
    type,
    enabled: !!meta.alwaysOn || !!meta.defaultOn,
    channel: AutomationChannelEnum.SMS,
    message: meta.defaultMessage,
    settings,
  };
};
